import { LocationDescriptorObject } from "history";
import queryString from 'query-string';
import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";

import { IMenuPage } from "common/form/fields/PageField";
import { PanelSetupRequired } from "core/components/editor/EditToggle";
import initialState from "core/reducers/initialState";
import UrlUtil from "core/util/UrlUtil";


interface IPageRedirectOwnProps {
	data: IMenuPage;
	params?: object;
	preserveParams?: boolean;
}

interface IPageRedirectStateProps {
	to: LocationDescriptorObject;
}

type ResultProps = IPageRedirectOwnProps & IPageRedirectStateProps;

function mapStateToProps(store: any = initialState, { data = {} as IMenuPage, params, preserveParams }: IPageRedirectOwnProps): IPageRedirectStateProps {

	const { instance, path } = data;

	const existingParams = queryString.parse(store.router.location.search);

	const to = {
		search: queryString.stringify(preserveParams ? {...existingParams, ...params} : params),
		pathname: (instance && store.config.panels[instance]) ? UrlUtil.getLink(path, store.config.panels[instance].path) : undefined
	};

	return { to };
}

const PageRedirect: React.SFC<ResultProps> = ({to}) => {

	if (!to || !to.pathname) {
		return (
			<PanelSetupRequired description="Select a redirect target page." />
		);
	}

	return (
		<Redirect to={to} />
	);
};

export default connect(mapStateToProps)(PageRedirect);



// WEBPACK FOOTER //
// ./src/common/fragments/PageRedirect.tsx